import { handleAcceptNewChat, handleRejectNewChat } from "../../../../redux/user-slices/chat.slice"
import { Box, Button, ListItemText, Stack, Typography } from "@mui/material"
import { useDispatch, useSelector } from "react-redux"
import { setCurrectChat } from "../../../../redux/user-slices/socket.slice"

function Concent() {
  const dispatch = useDispatch()
  const { chat, socket } = useSelector((state) => state.socketSlice)
  const { member, specialist } = useSelector((state) => state.authSlice);

  // --------------- Handle accept chat ---------------
  const handleAccept = async () => {
    const { success } = await dispatch(handleAcceptNewChat(chat?._id)).unwrap()
    if (success) {
      dispatch(setCurrectChat({ ...chat, status: "accepted" }));
      socket.emit("get-chats", { userId: (member?._id || specialist?.specialist?._id || specialist?._id), currentPage: 1, limit: 20 });
    }
  }

  // --------------- Handle reject chat ---------------
  const handleReject = () => {
    dispatch(handleRejectNewChat(chat?._id)).unwrap()
  }

  return (
    <Box
      sx={{
        gap: 1,
        display: "flex",
        justifyContent: "center"
      }}
    >
      <ListItemText
        sx={{
          m: 0,
          p: 1,
          maxWidth: "90%",
          width: "fit-content",
          bgcolor: "white",
          borderRadius: "5px",
        }}
        primary={<><Typography component="span" fontWeight="500" textTransform="capitalize">{chat?.user?.fullName}</Typography> wants to have a conversation with you!</>}
        secondary={
          <Stack mt={1} spacing={1} direction="row" alignItems="center" justifyContent="center">
            <Button
              disableRipple
              btnvariant="linkButton"
              onClick={handleAccept}
            >Accept
            </Button>
            <Button
              disableRipple
              btnvariant="linkButton"
              onClick={handleReject}
            >Reject
            </Button>
          </Stack>
        }
        slotProps={{
          primary: { sx: { fontSize: 15, lineHeight: 1.2, textAlign: "center" } },
          secondary: { sx: { fontSize: 13, lineHeight: 1.2 }, component: "div" },
        }}
      />
    </Box>
  )
}

export default Concent